const firstCharacter = (name) => name[0].toUpperCase();

export default function (fname, lname) {
  if (fname && lname) {
    return `${firstCharacter(fname)}${firstCharacter(lname)}`;
  }

  return fname;
}
